// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore"; // ✅ Add this line

const firebaseConfig = {
  apiKey: "AIzaSyA8J3YuML0oEL_WbSg3bNMWUHj2kSKSnNQ",
  authDomain: "dot-connect-b781d.firebaseapp.com",
  projectId: "dot-connect-b781d",
  storageBucket: "dot-connect-b781d.firebasestorage.app",
  messagingSenderId: "792541507494",
  appId: "1:792541507494:web:0b3c65ce94ffa56f102967"
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const db = getFirestore(app); // ✅ Add this line

export { auth, provider, db }; // ✅ Export db
